/* CSS modules — local to @ahimsa/aletheia-runner. No Tailwind, no global
   leaks: every class is scoped via Vite's CSS modules pipeline so the
   host page (or another widget on the same page) cannot collide. */

.shell {
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #1f2937;
  padding: 20px;
  max-width: 720px;
  margin: 0 auto;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
}

.prompt {
  font-size: 18px;
  line-height: 1.45;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.passage {
  font-size: 15px;
  line-height: 1.55;
  color: #374151;
  background: #f9fafb;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e5e7eb;
}

.passage h2,
.passage h3 {
  margin-top: 0;
}

.optionList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.optionButton {
  appearance: none;
  background: #ffffff;
  border: 1.5px solid #d1d5db;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 16px;
  font-family: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  transition: transform 0.05s ease, border-color 0.15s ease, background 0.15s ease;
  touch-action: manipulation;
}

.optionButton:hover {
  border-color: #3a86ff;
}

.optionButton:active {
  transform: scale(0.985);
}

.optionSelected {
  border-color: #3a86ff;
  background: #eff6ff;
}

.optionCorrect {
  border-color: #06a77d;
  background: #ecfdf5;
}

.optionWrong {
  border-color: #ef4444;
  background: #fef2f2;
}

.primaryButton {
  appearance: none;
  background: linear-gradient(135deg, #3a86ff 0%, #4338ca 100%);
  color: #fff;
  border: none;
  border-radius: 14px;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  align-self: stretch;
  touch-action: manipulation;
}

.primaryButton:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}

.secondaryButton {
  appearance: none;
  background: transparent;
  color: #3a86ff;
  border: 1.5px solid #93c5fd;
  border-radius: 12px;
  padding: 10px 14px;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  touch-action: manipulation;
}

.summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #f0fdf4;
  border: 1.5px solid #06a77d;
  border-radius: 14px;
  padding: 18px;
}

.summaryFail {
  background: #fef2f2;
  border-color: #ef4444;
}

.scoreBadge {
  display: inline-block;
  font-size: 32px;
  font-weight: 800;
  color: #0f172a;
}

.bucket {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f3f4f6;
  border: 1.5px dashed #9ca3af;
  border-radius: 12px;
  padding: 12px;
  min-height: 80px;
}

.bucketTitle {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #4b5563;
}

.dragItem {
  appearance: none;
  background: #ffffff;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 15px;
  font-family: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  touch-action: manipulation;
}

.dragItemActive {
  border-color: #3a86ff;
  background: #eff6ff;
}

.row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.grid2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

@media (min-width: 480px) {
  .grid2 {
    grid-template-columns: 1fr 1fr;
  }
}

.canvasWrap {
  display: flex;
  justify-content: center;
}

.sliderLabel {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #4b5563;
}
